import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useGetPhysicalBooks = (queryParams) => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const res = await instance.get(`books/physical`, {
			params,
		});
		return res.data;
	};

	return useQuery(["books", "physical-books", queryParams], () => fetch(), {
		...fetchConfig,
		keepPreviousData: true,
	});
};

export default useGetPhysicalBooks;
